import { Routes, RouterModule } from '@angular/router';
import { DetalheCursoComponent } from './detalhe-curso.component';
import { SobreOProgramaComponent } from './sobre-o-programa/sobre-o-programa.component';
import { DisciplinasComponent } from './disciplinas/disciplinas.component';
import { CorpoDocenteComponent } from './corpo-docente/corpo-docente.component';
import { ProcessoSeletivoComponent } from './processo-seletivo/processo-seletivo.component';
// import { DetalheCursoRedeBionorteComponent } from '../detalhe-curso-rede/rede-bionorte/rede-bionorte.component';
// import { DetalheCursoRedeReamecComponent } from '../detalhe-curso-rede/rede-reamec/rede-reamec.component';

export const DETALHE_CURSO_ROUTER: Routes = [
  {
    path: 'doutorado/:curso',
    component: DetalheCursoComponent,
    children: [
      {
        path: '',
        redirectTo: 'sobre-o-programa',
        pathMatch: 'full',
      },
      {
        path: 'sobre-o-programa',
        component: SobreOProgramaComponent,
      },
      {
        path: 'disciplinas',
        component: DisciplinasComponent,
      },
      {
        path: 'corpo-docente',
        component: CorpoDocenteComponent,
      },
      {
        path: 'processo-seletivo',
        component: ProcessoSeletivoComponent,
      },
    ],
  },
];

export const DetalheCursoRouter = RouterModule.forChild(DETALHE_CURSO_ROUTER);
